import React from "react";
import "./Commission_Details_card.css";

function Commission_Details_card() {
  return (
    <>
      <section className="Commission_Details_card">
        <div className="card_header">
          <h3>Settlement successful</h3>
          <p>2026-02-13 02:09:23</p>
          <span>
            The commission has been automatically credited to your balance
          </span>
        </div>

        <div className="card_body">
          <div className="row me-0 ms-0">
            <div className="col-6">
              <p>Number of bettors</p>
            </div>
            <div className="col-6">
              <p className="details_text">1 People</p>
            </div>
          </div>

          <div className="row me-0 ms-0">
            <div className="col-6">
              <p>Bet amount</p>
            </div>
            <div className="col-6">
              <p className="details_text">32</p>
            </div>
          </div>

          <div className="row me-0 ms-0 ">
            <div className="col-6">
              <p>Commission payout</p>
            </div>
            <div className="col-6 ">
              <p className="details_text highlight">0.19</p>
            </div>
          </div>

          <div className="row me-0 ms-0">
            <div className="col-6">
              <p>Date</p>
            </div>
            <div className="col-6">
              <p className="details_text">2026-02-12 00:00:00</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Commission_Details_card;
